import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReceiptIcon from "@mui/icons-material/Receipt";
import {
  Accordion,
  AccordionDetails,
  Typography,
  AccordionSummary,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function InitialOrder() {
  const location = useLocation();
  let serial_number =
    location.pathname.split("/")[location.pathname.split("/").length - 2];
  let business_partner =
    location.pathname.split("/")[location.pathname.split("/").length - 1];

  let placeholder_id = serial_number + "#" + business_partner;
  // The parse/stringify cheap cloning trick is to create a local copy of the state object
  const placeholderMaterial = useSelector((state) => {
    let _placeholderMaterial = state?.placeholderMaterials?.find(
      (m) => m.placeholder_id === placeholder_id,
    );
    if (_placeholderMaterial) {
      return JSON.parse(JSON.stringify(_placeholderMaterial));
    } else return {};
  });

  const rows = [
    { name: "Order ID", value: placeholderMaterial?.old_order_id },
    { name: "Purchase Order", value: placeholderMaterial?.old_purchase_order },
  ];

  return (
    <React.Fragment>
      <div style={{ width: "100%" }}>
        <TableContainer component={Paper}>
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              style={{
                backgroundColor: "#6b469e",
                color: "white",
                height: "3vh",
              }}
              sx={{
                "&.Mui-expanded": {
                  minHeight: 0,
                },
                "&.MuiAccordionSummary-root": {
                  minHeight: 0,
                },
              }}
              expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
            >
              <Typography
                style={{
                  width: "100%",
                }}
              >
                <ReceiptIcon
                  style={{ marginRight: "1%", verticalAlign: "middle" }}
                />
                Inital Order
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Table
                sx={{ minWidth: "30%" }}
                size="small"
                aria-label="serial number reference table"
              >
                <TableBody>
                  {rows.map((row, i) => {
                    if (row.value) {
                      return (
                        <TableRow>
                          <TableCell key={row.name + i + " namecell"}>
                            {row.name}
                          </TableCell>
                          <TableCell key={row.value + i + " valuecell"}>
                            {row.value}
                          </TableCell>
                        </TableRow>
                      );
                    }
                  })}
                </TableBody>
              </Table>
            </AccordionDetails>
          </Accordion>
        </TableContainer>
      </div>
    </React.Fragment>
  );
}
